import { Api } from 'models/services/api';
import { ReadRelationshipsByBusinessIdQuery } from 'models/services/graphql';

import { RelationshipCollectionData } from '../collection';

type DataToFetch = {
  businessId: string;
  limit?: number;
  nextToken?: string;
};

const RequestQuery = `
  query ReadRelationshipsByBusinessId($businessId: ID!, $limit: Int, $nextToken: String) {
    ${ReadRelationshipsByBusinessIdQuery}
  }
`;

type ResponseData = {
  data: {
    readRelationshipsByBusinessId: RelationshipCollectionData;
  }
}

class ReadCollectionByBusinessIdGql {

  readonly result?: RelationshipCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readRelationshipsByBusinessId;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionByBusinessIdGql };
